/**
 * Stock Exchange Switcher
 * Shared exchange-switching logic for HomePageHero and StockKeyMetrics
 * Slide animation + number counting on SIX/Xetra toggle
 */
(function () {
    /**
     * Animate a number from old to new value with counting effect
     */
    function animateNumber(el, newValue, decimals, duration, prefix, suffix) {
        if (!el) return;
        prefix = prefix || '';
        suffix = suffix || '';
        var startValue = parseFloat(el.textContent.replace(/[^0-9.\-]/g, '')) || 0;
        var endValue = parseFloat(newValue) || 0;
        if (startValue === endValue) {
            el.textContent = prefix + newValue + suffix;
            return;
        }
        var startTime = null;
        function step(timestamp) {
            if (!startTime) startTime = timestamp;
            var progress = Math.min((timestamp - startTime) / duration, 1);
            var eased = 1 - Math.pow(1 - progress, 3);
            var current = startValue + (endValue - startValue) * eased;
            el.textContent = prefix + current.toFixed(decimals) + suffix;
            if (progress < 1) {
                requestAnimationFrame(step);
            } else {
                el.textContent = prefix + newValue + suffix;
            }
        }
        requestAnimationFrame(step);
    }

    /**
     * Parse the label prefix from a timestamp element (preserves translated label)
     */
    function getTimestampLabel(el) {
        if (!el) return '';
        var text = el.textContent;
        var match = text.match(/^(.+?\s)(\d)/);
        return match ? match[1] : '';
    }

    /**
     * Update discount/premium label text from data attributes
     */
    function updateDiscountLabel(el, navPositive) {
        if (!el) return;
        var premiumText = el.getAttribute('data-label-premium') || 'Premium to NAV';
        var discountText = el.getAttribute('data-label-discount') || 'Discount to NAV';
        el.textContent = navPositive ? premiumText : discountText;
    }

    // ========================================
    // HomePageHero Exchange Switcher
    // Uses event delegation for swup page transitions
    // ========================================
    document.addEventListener('click', function (e) {
        var btn = e.target.closest('.stock-ticker .exchange-btn');
        if (!btn) return;

        e.preventDefault();

        var ticker = btn.dataset.ticker || '';
        var price = btn.dataset.price || '';
        var currency = btn.dataset.currency || '';
        var lastUpdate = btn.dataset.lastUpdate || '';
        var changeAbsolute = btn.dataset.changeAbsolute || '0.00';
        var changePercent = btn.dataset.changePercent || '0.00';
        var changePositive = btn.dataset.changePositive === 'true';
        var navDiscount = btn.dataset.navDiscount || '0.0';
        var navPositive = btn.dataset.navPositive === 'true';
        var navFormatted = btn.dataset.navFormatted || '0.00';

        var stockTicker = btn.closest('.stock-ticker');
        if (!stockTicker) return;

        if (stockTicker.classList.contains('is-switching') || btn.classList.contains('exchange-active')) return;

        // Update exchange button states
        stockTicker.querySelectorAll('.exchange-btn').forEach(function (b) {
            b.classList.remove('exchange-active');
            b.classList.add('exchange-inactive');
        });
        btn.classList.remove('exchange-inactive');
        btn.classList.add('exchange-active');

        // Slide out
        stockTicker.classList.add('is-switching');

        setTimeout(function () {
            // Update ticker symbol
            var tickerSymbol = stockTicker.querySelector('.stock-ticker-symbol');
            if (tickerSymbol) tickerSymbol.textContent = ticker;

            // Update currencies
            var stockCurrency = stockTicker.querySelector('.stock-currency');
            if (stockCurrency) stockCurrency.textContent = currency;
            var navCurrency = stockTicker.querySelector('.nav-currency');
            if (navCurrency) navCurrency.textContent = currency;

            // Update timestamps (preserve translated label prefix)
            stockTicker.querySelectorAll('.stock-time').forEach(function (el) {
                if (lastUpdate) {
                    var label = getTimestampLabel(el);
                    el.textContent = label + lastUpdate;
                }
            });

            // Update change badge
            stockTicker.querySelectorAll('.stock-change').forEach(function (stockChange) {
                stockChange.classList.remove('stock-change-negative');
                if (!changePositive) stockChange.classList.add('stock-change-negative');
                var stockArrow = stockChange.querySelector('.stock-arrow');
                if (stockArrow) {
                    stockArrow.classList.remove('arrow-down');
                    if (!changePositive) stockArrow.classList.add('arrow-down');
                }
                var absEl = stockChange.querySelector('.change-absolute');
                if (absEl) absEl.textContent = (changePositive ? '+' : '') + changeAbsolute;
                var pctEl = stockChange.querySelector('.change-percent');
                if (pctEl) pctEl.textContent = (changePositive ? '+' : '') + changePercent + '%';
            });

            // Update NAV discount styling
            stockTicker.querySelectorAll('.nav-discount').forEach(function (el) {
                el.classList.remove('text-success', 'text-error');
                el.classList.add(navPositive ? 'text-success' : 'text-error');
            });

            // Update discount/premium label (read from data attributes)
            stockTicker.querySelectorAll('.nav-label').forEach(function (el) {
                updateDiscountLabel(el, navPositive);
            });

            // Slide back in
            stockTicker.classList.remove('is-switching');

            // Animate numbers
            var stockPrice = stockTicker.querySelector('.stock-price');
            animateNumber(stockPrice, price, 2, 400);
            var navPrice = stockTicker.querySelector('.nav-price');
            animateNumber(navPrice, navFormatted, 2, 400);

            stockTicker.querySelectorAll('.nav-discount').forEach(function (el) {
                var prefix = navPositive ? '+' : '';
                animateNumber(el, navDiscount, 1, 300, prefix, '%');
            });
        }, 220);
    });

    // ========================================
    // StockKeyMetrics Exchange Switcher
    // ========================================
    function initStockKeyMetrics() {
        document.querySelectorAll('[data-stock-key-metrics]').forEach(function (container) {
            var card = container.querySelector('.key-metrics-stock-card');
            if (!card) return;

            var exchangeButtons = card.querySelectorAll('.stock-exchange-link');
            if (!exchangeButtons.length) return;

            var tickerSymbol = card.querySelector('.stock-ticker-symbol');
            var priceEl = card.querySelector('.stock-price');
            var currencyEl = card.querySelector('.stock-currency');
            var navPriceEl = card.querySelector('.nav-price');
            var navCurrencyEl = card.querySelector('.nav-currency');
            var navDiscountEl = card.querySelector('.nav-discount');
            var discountLabel = card.querySelector('.stock-discount-label');
            var timestamp = card.querySelector('.stock-timestamp');

            exchangeButtons.forEach(function (button) {
                button.addEventListener('click', function (e) {
                    e.preventDefault();

                    if (card.classList.contains('is-switching') || button.classList.contains('stock-exchange-link--active')) return;

                    // Update active state
                    exchangeButtons.forEach(function (btn) {
                        btn.classList.remove('stock-exchange-link--active', 'text-inverse-strong', 'underline');
                        btn.classList.add('text-inverse-weak', 'no-underline');
                    });
                    button.classList.add('stock-exchange-link--active', 'text-inverse-strong', 'underline');
                    button.classList.remove('text-inverse-weak', 'no-underline');

                    var ticker = button.getAttribute('data-ticker');
                    var price = button.getAttribute('data-price');
                    var currency = button.getAttribute('data-currency');
                    var lastUpdateFormatted = button.getAttribute('data-last-update-formatted');
                    var navFormatted = button.getAttribute('data-nav-formatted');
                    var navDiscount = button.getAttribute('data-nav-discount');
                    var navPositive = button.getAttribute('data-nav-positive') === 'true';

                    card.classList.add('is-switching');

                    setTimeout(function () {
                        if (tickerSymbol) tickerSymbol.textContent = ticker;
                        if (currencyEl) currencyEl.textContent = currency;
                        if (navCurrencyEl) navCurrencyEl.textContent = currency;

                        if (navDiscountEl) {
                            navDiscountEl.classList.remove('text-success', 'text-inverse-strong');
                            navDiscountEl.classList.add(navPositive ? 'text-success' : 'text-inverse-strong');
                        }

                        if (discountLabel) {
                            updateDiscountLabel(discountLabel, navPositive);
                        }

                        if (timestamp && lastUpdateFormatted) {
                            var label = getTimestampLabel(timestamp);
                            timestamp.textContent = label + lastUpdateFormatted;
                        }

                        card.classList.remove('is-switching');

                        animateNumber(priceEl, price, 2, 400);
                        animateNumber(navPriceEl, navFormatted, 2, 400);

                        if (navDiscountEl) {
                            var discountPrefix = navPositive ? '+' : '';
                            animateNumber(navDiscountEl, navDiscount, 1, 300, discountPrefix, '%');
                        }

                        // Update switchable metric values in grid (light side)
                        var exchange = button.getAttribute('data-exchange');
                        var switchables = container.querySelectorAll('.key-metrics-switchable');
                        switchables.forEach(function (el) {
                            var val = el.getAttribute('data-' + exchange + '-value');
                            if (val) el.textContent = val;
                        });

                        // Update NAV value in metrics grid (light side)
                        var navValueEl = container.querySelector('.key-metrics-nav-value');
                        if (navValueEl && navFormatted) {
                            navValueEl.textContent = navFormatted;
                            navValueEl.classList.remove('text-success-strong');
                            if (navPositive) navValueEl.classList.add('text-success-strong');
                        }

                        // Update NAV metric item positive/negative state
                        var navItem = navValueEl ? navValueEl.closest('.key-metrics-value') : null;
                        if (navItem) {
                            navItem.classList.remove('is-positive', 'is-negative');
                            navItem.classList.add(navPositive ? 'is-positive' : 'is-negative');
                        }
                        var navBar = navItem ? navItem.parentElement.querySelector('.key-metrics-metric-bar') : null;
                        if (navBar) {
                            navBar.classList.remove('is-positive', 'is-negative');
                            navBar.classList.add(navPositive ? 'is-positive' : 'is-negative');
                        }
                    }, 220);
                });
            });
        });
    }

    // ========================================
    // Auto-select exchange from URL parameter
    // ========================================
    function autoSelectFromUrl() {
        var params = new URLSearchParams(window.location.search);
        var exchange = params.get('exchange');
        if (!exchange) return;
        var exchangeLower = exchange.toLowerCase();

        // StockKeyMetrics: data-exchange values are lowercase ("six", "xetra")
        document.querySelectorAll('[data-stock-key-metrics] .stock-exchange-link').forEach(function (btn) {
            if (btn.getAttribute('data-exchange') === exchangeLower && !btn.classList.contains('stock-exchange-link--active')) {
                btn.click();
            }
        });

        // HomePageHero: data-exchange values are mixed case ("SIX", "Xetra")
        var heroValue = exchangeLower === 'xetra' ? 'Xetra' : 'SIX';
        document.querySelectorAll('.stock-ticker .exchange-btn').forEach(function (btn) {
            if (btn.getAttribute('data-exchange') === heroValue && !btn.classList.contains('exchange-active')) {
                btn.click();
            }
        });
    }

    function init() {
        initStockKeyMetrics();
        autoSelectFromUrl();
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
    } else {
        init();
    }
})();
